// extracted by mini-css-extract-plugin
module.exports = {"container":"TagSelect_container__11Lbf","tag":"TagSelect_tag__3Ly51","active":"TagSelect_active__14QIu"};